import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Landing from "./pages/Landing";
import Layout from "./pages/Layout";
import Overview from "./pages/Overview";
import Acquisti from "./pages/Acquisti";
import PriceTrends from "./pages/PriceTrends";
import Suppliers from "./pages/Suppliers";
import Products from "./pages/Products";
import Sales from "./pages/Sales";
import Alerts from "./pages/Alerts";
import Billing from "./pages/Billing";
import Admin from "./pages/Admin";
import Plans from "./pages/Plans";
import Settings from "./pages/Settings";
import Anagrafica from "./pages/Anagrafica";
import AziendaProfile from "./pages/AziendaProfile";
import SuppliersRegistry from "./pages/SuppliersRegistry";
import ImportVendite from "./pages/ImportVendite";
import Marginalita from "./pages/Marginalita";
import Team from "./pages/Team";
import PaymentResult from "./pages/PaymentResult";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { PrivacyPolicy, CookiePolicy, TermsOfService } from "./pages/Legal";
import { CookieBanner } from "./components/CookieBanner";
import Procurement from "./pages/Procurement";
import Recipes from "./pages/Recipes";

function AuthOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-stone-400 font-serif text-2xl">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-stone-400 font-serif text-2xl">Caricamento…</div>;
  if (!user) return <Navigate to="/welcome" replace />;
  if (user.company_status && user.company_status !== "active" && user.platform_role !== "super_admin")
    return <Navigate to="/billing" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/welcome" element={<Landing />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/termini" element={<TermsOfService />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/billing" element={<AuthOnly><Billing /></AuthOnly>} />
      <Route path="/payment/success" element={<AuthOnly><PaymentResult /></AuthOnly>} />
      <Route path="/payment/cancel" element={<AuthOnly><PaymentResult /></AuthOnly>} />
      <Route path="/" element={<Protected><Layout /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="acquisti" element={<Acquisti />} />
        <Route path="andamento" element={<PriceTrends />} />
        <Route path="fornitori" element={<Suppliers />} />
        <Route path="prodotti" element={<Products />} />
        <Route path="anagrafica" element={<Anagrafica />} />
        <Route path="azienda" element={<AziendaProfile />} />
        <Route path="anagrafica-fornitori" element={<SuppliersRegistry />} />
        <Route path="vendite" element={<Sales />} />
        <Route path="import-vendite" element={<ImportVendite />} />
        <Route path="marginalita" element={<Marginalita />} />
        <Route path="avvisi" element={<Alerts />} />
        <Route path="procurement" element={<Procurement />} />
        <Route path="ricette" element={<Recipes />} />
        <Route path="team" element={<Team />} />
        <Route path="admin" element={<Admin />} />
        <Route path="piani" element={<Plans />} />
        <Route path="impostazioni" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <CookieBanner />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
